var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[(_vm.showAppChrome)?_c('AppHeader'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"app-body",class:{ 'app-body-public': !_vm.showAppChrome }},[(_vm.showAppChrome)?_c('Sidebar',{attrs:{"navItems":_vm.nav}}):_vm._e(),_vm._v(" "),_c('main',{staticClass:"main",class:{ 'main-public': !_vm.showAppChrome }},[_c('div',{staticClass:"container-fluid backoffice-content"},[_c('router-view')],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5243c49b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Full.vue
// module id = 750
// module chunks = 1